import { useTranslation } from 'react-i18next'

import { AIButtonContainedGrey } from '../../../AIButton'
import { ICON_COLOR, ICON_HEIGHT_20, IconNG } from '../../../Icon'
import Text from '../../../Text'
import { GRETA_AI_CHAT_PROJECT_META_SEPARATOR } from '../../GretaAIChat.constants'
import { formatGretaAIChatTimeRelative } from '../../GretaAIChat.utils'
import { getGretaAIChatProjectScopeLabel } from '../../GretaAIChat.utils.projects'
import { GretaAIChatProjectName } from '../../GretaAIChatProjectName'

import { QA_NAME_GRETA_AI_CHAT_PROJECTS_PAGE_CARD } from './GretaAIChatProjectsPageCard.constants'

import * as styles from './GretaAIChatProjectsPageCard.module.css'

import FolderIcon from '../../../../icons/folder.svg'

function GretaAIChatProjectsPageCard({ locale, now, project }) {
  const { t } = useTranslation()

  return (
    <AIButtonContainedGrey
      className={styles.card}
      qaName={QA_NAME_GRETA_AI_CHAT_PROJECTS_PAGE_CARD}
    >
      <span className={styles.head}>
        <IconNG
          Icon={FolderIcon}
          className={styles.icon}
          color={ICON_COLOR.SecondaryTextColor}
          size={ICON_HEIGHT_20}
        />
        <GretaAIChatProjectName className={styles.name} name={project.name} />
      </span>
      <Text className={styles.scope}>
        {getGretaAIChatProjectScopeLabel(project.subject, t)}
      </Text>
      <Text isSecondary className={styles.meta}>
        {t('Greta.ProjectChatsCountKey', { count: project.chats.length })}
        {GRETA_AI_CHAT_PROJECT_META_SEPARATOR}
        {formatGretaAIChatTimeRelative(project.lastActivityAt, now, locale)}
      </Text>
    </AIButtonContainedGrey>
  )
}

export default GretaAIChatProjectsPageCard
